import React from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import { NoResults } from 'mailup-web-components'

import {
  modalBeeContentDialogResultsState,
  modalBeeContentDialogContentsState
} from '../recoil/state'

import SearchContentsResult from './SearchContentsResult'
import SearchContentsOrderBy from './SearchContentsOrderBy'

const ResultsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  border-bottom: 2px solid var(--silver);

  & .c-button-with-menu__menu {
    right: -8px;
  }
`

const ResultsLabel = styled.p`
  color: var(--mine-shaft);
  font-size: 15px;
  font-weight: 500;
`

const ResultsLoader = styled.div`
  height: 460px;
  display: flex;

  align-items: center;
  justify-content: center;
`

const StyledNoResults = styled(NoResults)`
  &.b-no-results {
    margin-top: 10px;
  }
`

const SearchContentsResults = () => {
  const intl = useIntl()
  const { items } = useRecoilValue(modalBeeContentDialogResultsState)
  const { fetching } = useRecoilValue(modalBeeContentDialogContentsState)
  return (
    <>
      <ResultsHeader>
        <ResultsLabel>
          {intl.formatMessage({ id: 'Load.BeeContentDialog.Result' })}
        </ResultsLabel>

        <SearchContentsOrderBy />
      </ResultsHeader>
      {fetching ? (
        <ResultsLoader>
          <span className='is-loading' />
        </ResultsLoader>
      ) : (
        <>
          {items.length ? (
            <ul>
              {items.map((item, idx) => (
                <SearchContentsResult
                  key={`${idx}-${item.contentKey}`}
                  {...item}
                />
              ))}
            </ul>
          ) : (
            <StyledNoResults
              text={intl.formatMessage({
                id: 'Load.BeeContentDialog.NoContentsInSourceTitle'
              })}
            />
          )}
        </>
      )}
    </>
  )
}

export default SearchContentsResults
